import axios from "axios";

import { BASE_URL, NavigationPath, history } from "../utils";

const defaultOptions = (url: string | undefined, isFormData = false) => ({
  baseURL: `${url}`,
  headers: {
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  },
});

// Requests made with `responseType: "blob"` receive error bodies as a Blob;
// turn a JSON error body back into an object so its message can be shown.
const parseBlobErrorData = async (error: any) => {
  const data = error.response?.data;
  if (data instanceof Blob && data.type.includes("application/json")) {
    try {
      error.response.data = JSON.parse(await data.text());
    } catch (e) {}
  }
};

export const ApiService = axios.create(defaultOptions(BASE_URL));
export const ApiServiceFormData = axios.create(defaultOptions(BASE_URL, true));

ApiService.interceptors.request.use(
  (config) => {
    const userToken = localStorage.getItem("userToken");

    if (userToken) {
      config.headers["Authorization"] = `Bearer ${userToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ApiService.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    await parseBlobErrorData(error);

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const token = localStorage.getItem("refreshToken");
        const response = await axios.post(`${BASE_URL}/auth/refresh-token`, {
          refreshToken: token,
        });
        const { accessToken, refreshToken } = response.data;

        localStorage.setItem("userToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (error) {
        history.navigate(NavigationPath.LOGIN_ROUTE);
      }
    }

    return Promise.reject(error);
  }
);

ApiServiceFormData.interceptors.request.use(
  (config) => {
    const userToken = localStorage.getItem("userToken");

    if (userToken) {
      config.headers["Authorization"] = `Bearer ${userToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ApiServiceFormData.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    await parseBlobErrorData(error);

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const token = localStorage.getItem("refreshToken");
        const response = await axios.post(`${BASE_URL}/auth/refresh-token`, {
          refreshToken: token,
        });
        const { accessToken, refreshToken } = response.data;

        localStorage.setItem("userToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (error) {
        history.navigate(NavigationPath.LOGIN_ROUTE);
      }
    }

    return Promise.reject(error);
  }
);
